/*
 * @Author: WYX
 * @Date: 2019/12/26
 * @LastEditTime: 2021-05-19 10:46:06
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\directive\editPagePart\editPageVideoUpload\editPageVideoUpload.js
 * @Description: 新渠道视频稿件上传
 */

angular.module('editPageVideoUploadModule', []).directive('editPageVideoUpload', [
    'editCenUploadVideoForXjService',
    'messagePublishService',
    function(editCenUploadVideoForXjService, messagePublishService) {
        return {
            scope: true, // 继承作用域
            restrict: 'EA',
            templateUrl: './editingCenter/directive/editPagePart/editPageVideoUpload/editPageVideoUpload.html',
            replace: true,
            link: function($scope) {
                initStatus();
                initData();

                /**
                 * [initStatus description]初始化状态
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.uploader = {
                        example: '',
                        progress: 0,
                        fastVideoTimer: '',
                        canNotPlay: false,
                        fastVideoInfo: {}, // 视频快编信息
                        uploaderOptions: angular.extend({}, editCenUploadVideoForXjService.singleVideoOption), // 上传配置项
                    };
                }

                /**
                 * [initData description]初始化数据
                 *
                 * @return  {[type]}  [return description]
                 */
                function initData() {
                    if ($scope.parentStatus.articleid){
                        messagePublishService.subscribe(
                            `${$scope.parentStatus.mediaName}ListInit`,
                            function() {
                                LoadingHtml();
                            },
                            $scope
                        );
                    } else {
                        LoadingHtml();
                    }
                }

                /**
                 * 动态加载视频指令
                 * @constructor
                 */
                function LoadingHtml() {
                    let sendType = $scope.parentStatus.mediaName;
                    let videoUpload = '<div trs-upload-for-xj-video-draft list="list" storage-type="' + sendType + '" metadata="articleid"></div>';
                    videoUpload = $scope.compile(videoUpload)($scope);
                    $scope.element.find('videocon').append(videoUpload);
                    $scope.$apply();
                }
            },
        };
    },
]);
